import BookingFormField from './BookingFormField';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormInputs = ({
  formFields,
  customFormFields,
  onCustomFormFieldChange,
  formStateValidation,
  disabled
}) => /*#__PURE__*/_jsx("div", {
  style: {
    wordWrap: 'break-word'
  },
  children: formFields.map(field => {
    return /*#__PURE__*/_jsx(BookingFormField, {
      fieldValue: customFormFields.get(field.name),
      fieldName: field.name,
      validation: formStateValidation.get(field.name),
      setFormValue: onCustomFormFieldChange,
      type: field.type,
      fieldType: field.fieldType,
      isRequired: field.isRequired,
      fieldLabel: propertyLabelTranslator(field.label),
      fieldOptions: field.options,
      fieldIsCustom: field.isCustom,
      numberDisplayHint: field.numberDisplayHint,
      disabled: disabled
    }, `${field.name}`);
  })
});
export default CustomFormInputs;